import { AcUnitOutlined, AccountBalance, AccountBalanceOutlined, AccountTree, Add, AdminPanelSettings, AdminPanelSettingsOutlined, AirplanemodeActiveOutlined, Apartment, ApartmentOutlined, ArrowForwardIos, Assignment, AssignmentOutlined, Autorenew, BuildOutlined, Business, CalendarMonthOutlined, CancelOutlined, Check, CheckCircle, CheckCircleOutline, CheckCircleOutlined, CircleOutlined, Clear, Cloud, CloudOffOutlined, CloudOutlined, CommuteOutlined, CurrencyPound, DeleteOutline, DeleteOutlineOutlined, Description, DescriptionOutlined, DirectionsBikeOutlined, DirectionsBoatOutlined, DirectionsBus, DirectionsBusOutlined, DirectionsCarOutlined, DirectionsWalk, Done, EditOutlined, ElectricBolt, ElectricBoltOutlined, ElectricCarOutlined, ElectricScooter, EmailOutlined, EnergySavingsLeafOutlined, ErrorOutline, FactoryOutlined, FilterDrama, Flight, HandshakeOutlined, HeatPumpOutlined, HighlightOff, HomeWorkOutlined, HotelOutlined, HouseOutlined, HvacOutlined, InfoOutlined, Inventory2, Inventory2Outlined, LightbulbOutlined, LocalFireDepartmentOutlined, LocalGasStationOutlined, LocalShippingOutlined, LocalTaxi, Login, Logout, ManageAccounts, ManageAccountsOutlined, MicrowaveOutlined, MonetizationOn, OpacityOutlined, PedalBike, Poll, PollOutlined, PublishedWithChangesRounded, Ballot, BallotOutlined, Recycling, RecyclingOutlined, RemoveCircleOutlineOutlined, RotateRight, Scale, ShoppingBagOutlined, ShoppingCartOutlined, SolarPowerOutlined, SpaceDashboard, SpaceDashboardOutlined, StackedBarChart, StackedBarChartOutlined, StarBorderOutlined, StarOutlineOutlined, Store, SummarizeOutlined, ThermostatOutlined, TonalityOutlined, Train, TrainOutlined, TrendingDown, TwoWheeler, UploadOutlined, VerifiedUser, VisibilityOutlined, WaterOutlined, WindPowerOutlined, HideSourceOutlined, EditNote, CalculateOutlined, ReceiptLongOutlined, MenuBook, MenuBookOutlined, FactCheck, FactCheckOutlined, Lock, LockOutlined, Security, SecurityOutlined, VerifiedUserOutlined } from '@mui/icons-material';
import { Icon } from '@mui/material';
import { FunctionComponent, ReactElement, useEffect, useState } from 'react';
import { IconName } from '../../../shared/interfaces/icon-picker.model';

export const IconPicker: FunctionComponent<{ icon: IconName, color?: string, scale?: number }> = ({ icon, color, scale = 1 }) => {

  const [iconToDisplay, setIconToDisplay] = useState<ReactElement>()

  useEffect(() => {

    if (icon === IconName.Apartment) {
      setIconToDisplay(<Apartment />)
    }

    if (icon === IconName.DirectionsCarOutlined) {
      setIconToDisplay(<DirectionsCarOutlined />)
    }

    if (icon === IconName.ElectricBolt) {
      setIconToDisplay(<ElectricBolt />)
    }

    if (icon === IconName.ShoppingCartOutlined) {
      setIconToDisplay(<ShoppingCartOutlined />)
    }

    if (icon === IconName.BuildOutlined) {
      setIconToDisplay(<BuildOutlined />)
    }

    if (icon === IconName.LocalGasStationOutlined) {
      setIconToDisplay(<LocalGasStationOutlined />)
    }

    if (icon === IconName.LocalShippingOutlined) {
      setIconToDisplay(<LocalShippingOutlined />)
    }

    if (icon === IconName.DeleteOutlineOutlined) {
      setIconToDisplay(<DeleteOutlineOutlined />)
    }

    if (icon === IconName.Flight) {
      setIconToDisplay(<Flight />)
    }

    if (icon === IconName.DirectionsWalk) {
      setIconToDisplay(<DirectionsWalk />)
    }

    if (icon === IconName.AssignmentOutlined) {
      setIconToDisplay(<AssignmentOutlined />)
    }

    if (icon === IconName.Assignment) {
      setIconToDisplay(<Assignment />)
    }

    if (icon === IconName.MonetizationOn) {
      setIconToDisplay(<MonetizationOn />)
    }

    if (icon === IconName.Store) {
      setIconToDisplay(<Store />)
    }

    if (icon === IconName.ShoppingBagOutlined) {
      setIconToDisplay(<ShoppingBagOutlined />)
    }

    if (icon === IconName.Recycling) {
      setIconToDisplay(<Recycling />)
    }

    if (icon === IconName.FactoryOutlined) {
      setIconToDisplay(<FactoryOutlined />)
    }

    if (icon === IconName.Star) {
      setIconToDisplay(<StarOutlineOutlined />)
    }

    if (icon === IconName.EnergySavingsLeafOutlined) {
      setIconToDisplay(<EnergySavingsLeafOutlined />)
    }

    if (icon === IconName.AcUnitOutlined) {
      setIconToDisplay(<AcUnitOutlined />)
    }

    if (icon === IconName.ElectricCarOutlined) {
      setIconToDisplay(<ElectricCarOutlined />)
    }

    if (icon === IconName.OpacityOutlined) {
      setIconToDisplay(<OpacityOutlined />)
    }

    if (icon === IconName.WaterOutlined) {
      setIconToDisplay(<WaterOutlined />)
    }

    if (icon === IconName.DeleteOutline) {
      setIconToDisplay(<DeleteOutline />)
    }

    if (icon === IconName.AirplanemodeActiveOutlined) {
      setIconToDisplay(<AirplanemodeActiveOutlined />)
    }

    if (icon === IconName.DirectionsBoatOutlined) {
      setIconToDisplay(<DirectionsBoatOutlined />)
    }

    if (icon === IconName.HotelOutlined) {
      setIconToDisplay(<HotelOutlined />)
    }

    if (icon === IconName.HomeWorkOutlined) {
      setIconToDisplay(<HomeWorkOutlined />)
    }

    if (icon === IconName.RemoveCircleOutlineOutlined) {
      setIconToDisplay(<RemoveCircleOutlineOutlined />)
    }

    if (icon === IconName.Done) {
      setIconToDisplay(<Done />)
    }

    if (icon === IconName.PedalBike) {
      setIconToDisplay(<PedalBike />)
    }

    if (icon === IconName.LocalTaxi) {
      setIconToDisplay(<LocalTaxi />)
    }

    if (icon === IconName.DirectionsBus) {
      setIconToDisplay(<DirectionsBus />)
    }

    if (icon === IconName.Train) {
      setIconToDisplay(<Train />)
    }

    if (icon === IconName.TwoWheeler) {
      setIconToDisplay(<TwoWheeler />)
    }

    if (icon === IconName.ElectricScooter) {
      setIconToDisplay(<ElectricScooter />)
    }

    if (icon === IconName.SpaceDashboardOutlined) {
      setIconToDisplay(<SpaceDashboardOutlined />)
    }

    if (icon === IconName.SpaceDashboard) {
      setIconToDisplay(<SpaceDashboard />)
    }

    if (icon === IconName.AccountBalanceOutlined) {
      setIconToDisplay(<AccountBalanceOutlined />)
    }

    if (icon === IconName.AccountBalance) {
      setIconToDisplay(< AccountBalance />)
    }


    if (icon === IconName.FilterDrama) {
      setIconToDisplay(< FilterDrama />)
    }


    if (icon === IconName.Cloud) {
      setIconToDisplay(< Cloud />)
    }


    if (icon === IconName.StackedBarChartOutlined) {
      setIconToDisplay(<StackedBarChartOutlined />)
    }


    if (icon === IconName.StackedBarChart) {
      setIconToDisplay(<StackedBarChart />)
    }


    if (icon === IconName.DescriptionOutlined) {
      setIconToDisplay(<DescriptionOutlined />)
    }


    if (icon === IconName.Description) {
      setIconToDisplay(<Description />)
    }


    if (icon === IconName.AdminPanelSettingsOutlined) {
      setIconToDisplay(<AdminPanelSettingsOutlined />)
    }


    if (icon === IconName.AdminPanelSettings) {
      setIconToDisplay(<AdminPanelSettings />)
    }


    if (icon === IconName.CheckCircle) {
      setIconToDisplay(<CheckCircle />)
    }

    if (icon === IconName.CheckCircleOutlined) {
      setIconToDisplay(<CheckCircleOutlined />)
    }

    if (icon === IconName.RotateRight) {
      setIconToDisplay(<RotateRight />)
    }

    if (icon === IconName.PollOutlined) {
      setIconToDisplay(<PollOutlined
      />)
    }

    if (icon === IconName.Poll) {
      setIconToDisplay(<Poll />)
    }

    if (icon === IconName.BallotOutlined) {
      setIconToDisplay(<BallotOutlined />)
    }

    if (icon === IconName.Ballot) {
      setIconToDisplay(<Ballot />)
    }

    if (icon === IconName.CalendarMonthOutlined) {
      setIconToDisplay(<CalendarMonthOutlined
      />)
    }

    if (icon === IconName.CloudOutlined) {
      setIconToDisplay(<CloudOutlined
      />)
    }

    if (icon === IconName.TonalityOutlined) {
      setIconToDisplay(<TonalityOutlined
      />)
    }

    if (icon === IconName.CircleOutlined) {
      setIconToDisplay(<CircleOutlined
      />)
    }

    if (icon === IconName.TrendingDown) {
      setIconToDisplay(<TrendingDown
      />)
    }

    if (icon === IconName.ArrowForwardIos) {
      setIconToDisplay(<ArrowForwardIos
      />)
    }

    if (icon === IconName.Add) {
      setIconToDisplay(<Add
      />)
    }

    if (icon === IconName.LocalFireDepartmentOutlined) {
      setIconToDisplay(<LocalFireDepartmentOutlined
      />)
    }

    if (icon === IconName.HeatPumpOutlined) {
      setIconToDisplay(<HeatPumpOutlined
      />)
    }

    if (icon === IconName.SolarPowerOutlined) {
      setIconToDisplay(<SolarPowerOutlined
      />)
    }

    if (icon === IconName.WindPowerOurlined) {
      setIconToDisplay(<WindPowerOutlined
      />)
    }

    if (icon === IconName.HvacOutlined) {
      setIconToDisplay(<HvacOutlined
      />)
    }

    if (icon === IconName.HouseOutlined) {
      setIconToDisplay(<HouseOutlined
      />)
    }

    if (icon === IconName.ThermostatOutlined) {
      setIconToDisplay(<ThermostatOutlined
      />)
    }

    if (icon === IconName.LightbulbOutlined) {
      setIconToDisplay(<LightbulbOutlined
      />)
    }

    if (icon === IconName.MicrowaveOutlined) {
      setIconToDisplay(<MicrowaveOutlined
      />)
    }

    if (icon === IconName.ElectricBoltOutlined) {
      setIconToDisplay(<ElectricBoltOutlined
      />)
    }

    if (icon === IconName.HandshakeOutlined) {
      setIconToDisplay(<HandshakeOutlined
      />)
    }

    if (icon === IconName.RecyclingOutlined) {
      setIconToDisplay(<RecyclingOutlined
      />)
    }

    if (icon === IconName.ApartmentOutlined) {
      setIconToDisplay(<ApartmentOutlined
      />)
    }

    if (icon === IconName.TrainOutlined) {
      setIconToDisplay(<TrainOutlined
      />)
    }

    if (icon === IconName.DirectionsBusOutlined) {
      setIconToDisplay(<DirectionsBusOutlined
      />)
    }

    if (icon === IconName.DirectionsBikeOutlined) {
      setIconToDisplay(<DirectionsBikeOutlined
      />)
    }

    if (icon === IconName.SummarizeOutlined) {
      setIconToDisplay(<SummarizeOutlined
      />)
    }

    if (icon === IconName.Factory) {
      setIconToDisplay(<FactoryOutlined
      />)
    }

    if (icon === IconName.Inventory2Outlined) {
      setIconToDisplay(<Inventory2Outlined
      />)
    }

    if (icon === IconName.Inventory2) {
      setIconToDisplay(<Inventory2
      />)
    }

    if (icon === IconName.ErrorOutline) {
      setIconToDisplay(<ErrorOutline
      />)
    }

    if (icon === IconName.Business) {
      setIconToDisplay(<Business
      />)
    }

    if (icon === IconName.AccountTree) {
      setIconToDisplay(<AccountTree
      />)
    }

    if (icon === IconName.UploadOutlined) {
      setIconToDisplay(<UploadOutlined
      />)
    }

    if (icon === IconName.HighlightOff) {
      setIconToDisplay(<HighlightOff
      />)
    }

    if (icon === IconName.EditOutlined) {
      setIconToDisplay(<EditOutlined
      />)
    }

    if (icon === IconName.Check) {
      setIconToDisplay(<Check
      />)
    }

    if (icon === IconName.Clear) {
      setIconToDisplay(<Clear
      />)
    }

    if (icon === IconName.CancelOutlined) {
      setIconToDisplay(<CancelOutlined
      />)
    }

    if (icon === IconName.ManageAccounts) {
      setIconToDisplay(<ManageAccountsOutlined />
      )
    }

    if (icon === IconName.Login) {
      setIconToDisplay(<Login />
      )
    }

    if (icon === IconName.InfoOutlined) {
      setIconToDisplay(<InfoOutlined />
      )
    }

    if (icon === IconName.StarBorderOutlined) {
      setIconToDisplay(<StarBorderOutlined />
      )
    }

    if (icon === IconName.Autorenew) {
      setIconToDisplay(<Autorenew />
      )
    }

    if (icon === IconName.PublishedWithChangesRounded) {
      setIconToDisplay(<PublishedWithChangesRounded />
      )
    }

    if (icon === IconName.MenuBook) {
      setIconToDisplay(<MenuBook />
      )
    }

    if (icon === IconName.FactCheck) {
      setIconToDisplay(<FactCheck />)
    }

    if (icon === IconName.FactCheckOutlined) {
      setIconToDisplay(<FactCheckOutlined />)
    }

    if (icon === IconName.MenuBookOutlined) {
      setIconToDisplay(<MenuBookOutlined />
      )
    }

    if (icon === IconName.VerifiedUser) {
      setIconToDisplay(<VerifiedUser />
      )
    }

    if (icon === IconName.VerifiedUserOutlined) {
      setIconToDisplay(<VerifiedUserOutlined />
      )
    }

    if (icon === IconName.Scale) {
      setIconToDisplay(<Scale />
      )
    }

    if (icon === IconName.CurrencyPound) {
      setIconToDisplay(<CurrencyPound />
      )
    }

    if (icon === IconName.HideSourceOutlined) {
      setIconToDisplay(<HideSourceOutlined />
      )
    }

    if (icon === IconName.EditNote) {
      setIconToDisplay(<EditNote />
      )
    }

    if (icon === IconName.CalculateOutlined) {
      setIconToDisplay(<CalculateOutlined />
      )
    }

    if (icon === IconName.EmailOutlined) {
      setIconToDisplay(<EmailOutlined />
      )
    }

    if (icon === IconName.ReceiptLongOutlined) {
      setIconToDisplay(<ReceiptLongOutlined />
      )
    }

    if (icon === IconName.Lock) {
      setIconToDisplay(<Lock />
      )
    }

    if (icon === IconName.LockOutlined) {
      setIconToDisplay(<LockOutlined />
      )
    }

    if (icon === IconName.Security) {
      setIconToDisplay(<Security />
      )
    }

    if (icon === IconName.SecurityOutlined) {
      setIconToDisplay(<SecurityOutlined />
      )
    }

    if (icon === IconName.FactCheck) {
      setIconToDisplay(<FactCheck />
      )
    }

    if (icon === IconName.FactCheckOutlined) {
      setIconToDisplay(<FactCheckOutlined />
      )
    }

  }, [color, icon])

  return (
    <Icon sx={{ color: color, transform: `scale(${scale})`, verticalAlign: 'middle', display: 'inline-flex', alignItems: 'center', overflow: 'visible' }}>
      {iconToDisplay}
    </Icon>
  )
}